// extracted by mini-css-extract-plugin
export default {"recipient-breakdown":"RecipientsBreakdown_recipient-breakdown__nEd1B"};